import { useSelector } from '../../state';
import AssitantUi from './assistantUI';
import { Button, Stack, Typography } from '@mui/material';

export default function Dashboard() {
  const { team } = useSelector(({ userSlice }) => userSlice);

  if (team === 'init' || team === 'loading') {
    return <div>Loading...</div>;
  }

  return (
    <Stack
      direction="column"
      spacing={2}
      justifyContent="center"
      alignItems="center"
      flexGrow={1}
    >
      <Stack>
        <div style={{ textAlign: 'center' }}>
          <Typography
            variant="h1"
            sx={{
              background:
                'linear-gradient(90deg,rgb(23,80,240),rgb(54, 150, 245),rgb(236, 166, 166))',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
            display="inline-block"
            fontWeight={500}
          >
            OrderFlow
          </Typography>
          <Typography variant="h1" display="inline-block">
            Ai
          </Typography>
        </div>
        <AssitantUi />
      </Stack>
    </Stack>
  );
}
